import { Component, Input, OnInit } from '@angular/core';
import { ControlButton } from '../viewModels/layout.viewModel';

@Component({
    selector: 'opath-core-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  @Input() controlButtons: ControlButton[];

  constructor() {}

  async ngOnInit(): Promise<void> {}
}
